import React, { useState, useEffect } from 'react';
import './index.css';
import { AuthProvider, useAuth } from './context/AuthContext';
import GirisPage from './pages/GirisPage';
import Sidebar from './components/Sidebar';
import YeniTalepPage from './pages/YeniTalepPage';
import TaleplerimPage from './pages/TaleplerimPage';
import TaleplerPage from './pages/TaleplerPage';
import BordroYuklePage from './pages/BordroYuklePage';
import KullanicilarPage from './pages/KullanicilarPage';
import MusterilerPage from './pages/MusterilerPage';
import BelgeYonetimPage from './pages/BelgeYonetimPage';
import StandartBelgelerPage from './pages/StandartBelgelerPage';
import AdayKayitPage from './pages/AdayKayitPage';
import AdayPaneliPage from './pages/AdayPaneliPage';
import AdayBilgileriPage from './pages/AdayBilgileriPage';
import HRAdaylarPage from './pages/HRAdaylarPage';
import SablonYonetimiPage from './pages/SablonYonetimiPage';
import RolYonetimiPage from './pages/RolYonetimiPage';
import MailAyarlariPage from './pages/MailAyarlariPage';
import SistemLoglariPage from './pages/SistemLoglariPage';
import SirketBilgileriPage from './pages/SirketBilgileriPage';
import MailSablonlariPage from './pages/MailSablonlariPage';
import IcerikYonetimiPage from './pages/IcerikYonetimiPage';
import KisiselBilgilerPage from './pages/KisiselBilgilerPage';
import ProfilimPage from './pages/ProfilimPage';
import EgitimYonetimiPage from './pages/EgitimYonetimiPage';
import EgitimlerimPage from './pages/EgitimlerimPage';
import EgitimRaporuPage from './pages/EgitimRaporuPage';
import IzinTalepPage from './pages/IzinTalepPage';
import IzinOnayPage from './pages/IzinOnayPage';
import VizeTaleplerHRPage from './pages/VizeTaleplerHRPage';
import PersonelListesiPage from './pages/PersonelListesiPage';
import PersonelKartiPage from './pages/PersonelKartiPage';
import YeniPersonelPage from './pages/YeniPersonelPage';
import OturumUyarisi from './components/OturumUyarisi';
import DepartmanYonetimiPage from './pages/DepartmanYonetimiPage';
import PozisyonYonetimiPage from './pages/PozisyonYonetimiPage';
import OrganizasyonSemasiPage from './pages/OrganizasyonSemasiPage';
import OnayAkisYonetimiPage from './pages/OnayAkisYonetimiPage';
import MasrafTalepPage from './pages/MasrafTalepPage';
import ZimmetYonetimiPage from './pages/ZimmetYonetimiPage';
import OnayBekleyenlerimPage from './pages/OnayBekleyenlerimPage';
import YonetimDashboardPage from './pages/YonetimDashboardPage';
import KadroTalepleriPage from './pages/KadroTalepleriPage';
import MusteriRaporuPage from './pages/MusteriRaporuPage';
import PersonelRaporuPage from './pages/PersonelRaporuPage';
import IsealimRaporuPage from './pages/IsealimRaporuPage';
import FinansalRaporuPage from './pages/FinansalRaporuPage';

const varsayilan = {
  personel: 'kisisel-bilgiler',
  muhasebeci: 'talepler',
  admin: 'yonetim-dashboard',
  hr: 'hr-adaylar',
  hr_super: 'kisisel-bilgiler',
  yonetici: 'yonetim-dashboard',
  aday: 'aday-bilgileri'
};

const AppIcerik = () => {
  const { kullanici, yukleniyor } = useAuth();
  const [aktifSayfa, setAktifSayfaState] = useState(() => {
    const path = window.location.pathname.replace(/^\//, '').split('/')[0];
    return path || null;
  });

  const setAktifSayfa = (sayfa) => {
    setAktifSayfaState(sayfa);
    if (sayfa) {
      window.history.pushState({ sayfa }, '', '/' + sayfa);
    }
  };

  useEffect(() => {
    const handlePop = () => {
      const path = window.location.pathname.replace(/^\//, '').split('/')[0];
      setAktifSayfaState(path || null);
    };
    window.addEventListener('popstate', handlePop);
    return () => window.removeEventListener('popstate', handlePop);
  }, []);

  if (yukleniyor) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--yazi-ikincil)' }}>
      Yukleniyor...
    </div>
  );

  if (!kullanici) {
    if (aktifSayfa === 'aday-kayit') return <AdayKayitPage girisSayfasinaGit={() => setAktifSayfa(null)} />;
    return <GirisPage sayfaDegistir={setAktifSayfa} />;
  }

  const sayfa = aktifSayfa || varsayilan[kullanici.rol] || 'yeni-talep';

  const render = () => {
    switch (sayfa) {
      case 'yeni-talep': return <YeniTalepPage />;
      case 'taleplerim': return <TaleplerimPage />;
      case 'talepler': return <TaleplerPage />;
      case 'bordro-yukle': return <BordroYuklePage />;
      case 'kullanicilar': return <KullanicilarPage />;
      case 'musteriler': return <MusterilerPage />;
      case 'belge-yonetimi': return <BelgeYonetimPage />;
      case 'standart-belgeler': return <StandartBelgelerPage />;
      case 'hr-adaylar': return <HRAdaylarPage />;
      case 'aday-paneli': return <AdayPaneliPage />;
      case 'aday-bilgileri': return <AdayBilgileriPage />;
      case 'sablon-yonetimi': return <SablonYonetimiPage />;
      case 'rol-yonetimi': return <RolYonetimiPage />;
      case 'mail-ayarlari': return <MailAyarlariPage />;
      case 'sistem-loglari': return <SistemLoglariPage />;
      case 'sirket-bilgileri': return <SirketBilgileriPage />;
      case 'mail-sablonlari': return <MailSablonlariPage />;
      case 'icerik-yonetimi': return <IcerikYonetimiPage />;
      case 'kisisel-bilgiler': return <ProfilimPage />;
      case 'egitim-yonetimi': return <EgitimYonetimiPage />;
      case 'egitimlerim': return <EgitimlerimPage />;
      case 'egitim-raporu': return <EgitimRaporuPage />;
      case 'izin-taleplerim': return <IzinTalepPage />;
      case 'izin-onay': return <IzinOnayPage />;
      case 'vize-talepler-hr': return <VizeTaleplerHRPage />;
      case 'personel-listesi': return <PersonelListesiPage />;
      case 'yeni-personel': return <YeniPersonelPage geriDon={() => setAktifSayfa('personel-listesi')} />;
      case 'departman-yonetimi': return <DepartmanYonetimiPage />;
      case 'pozisyon-yonetimi': return <PozisyonYonetimiPage />;
      case 'organizasyon': return <OrganizasyonSemasiPage />;
      case 'org-departman': return <DepartmanYonetimiPage />;
      case 'org-pozisyon': return <PozisyonYonetimiPage />;
      case 'onay-akis-yonetimi': return <OnayAkisYonetimiPage />;
      case 'masraf-taleplerim': return <MasrafTalepPage yonetim={false} />;
      case 'masraf-yonetimi': return <MasrafTalepPage yonetim={true} />;
      case 'zimmet-yonetimi': return <ZimmetYonetimiPage />;
      case 'onay-bekleyenlerim': return <OnayBekleyenlerimPage />;
      case 'yonetim-dashboard': return <YonetimDashboardPage />;
      case 'kadro-talepleri': return <KadroTalepleriPage />;
      case 'musteri-raporu': return <MusteriRaporuPage />;
      case 'personel-raporu': return <PersonelRaporuPage />;
      case 'isealim-raporu': return <IsealimRaporuPage />;
      case 'finansal-raporu': return <FinansalRaporuPage />;
      default: return <YeniTalepPage />;
    }
  };

  return (
    <div className="layout">
      <OturumUyarisi />
      <Sidebar aktifSayfa={sayfa} sayfaDegistir={setAktifSayfa} />
      <main className="main-content" style={{ minWidth: 0, maxWidth: '100%', overflowX: 'hidden' }}>
        {render()}
      </main>
    </div>
  );
};

function App() { return <AuthProvider><AppIcerik /></AuthProvider>; }
export default App;
